// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__QfHsc spinner-border","small":"LoadingSpinner_small__hb89T spinner-border-sm"};